import styled from 'styled-components'

export const Wrapper = styled.main`
  background: linear-gradient(0deg, #06092b, #06092b), #f1f3ff;
  width: 100%;
  height: 80vh;
  position: absolute;
  z-index: -99;
  top: 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 85%);
`
